import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button, Text, Tooltip } from 'lusha-ui-components-v2';
import { showPopup } from 'lusha-widgets';

import { IconFactory } from '../../assets/icons/IconFactory';
import DescriptionInfo from '../DescriptionInfo';

import './Notification.scss';

export const INDICATION = {
  SUCCESS: 'Success',
  FAIL: 'Fail',
  BLUE_FAIL: 'BlueFail',
};

const Notification = props => {
  const {
    closeToast,
    indication,
    message,
    description,
    action,
    onClick,
    title,
    className,
    btnVariant,
    onCloseClick,
    descriptionInTooltip,
    showOverflow,
    creditsCharged,
  } = props;

  function onAction(e) {
    onClick(e);
  }

  function onCloseClickWrapper() {
    if (onCloseClick) {
      onCloseClick();
      closeToast();
    } else {
      closeToast();
    }
  }

  const onDescriptionClick = useCallback(() => {
    if (!descriptionInTooltip) {
      showPopup(DescriptionInfo, { title, descriptionText: description });
    }
  }, [title, description, descriptionInTooltip]);

  return (
    <div className={`notification-container ${className}`}>
      <div className="notification-indication">
        {IconFactory(`${indication}Indication`)}
      </div>
      <div className={`notification-content ${action && onClick ? 'short' : 'long'}`}>
        <Text
          className={showOverflow ? 'notification-message-show-overflow' : 'notification-message'}
          variant="tinyR"
          color="seriousBlack"
        >
          {message}
        </Text>
        {description && <span
          onClick={onDescriptionClick}
          data-tip
          data-for="notification-description-tooltip"
          className="notification-description-icon"
        >
          {IconFactory('Info')}
        </span>}
        {description && descriptionInTooltip &&
          <Tooltip id="notification-description-tooltip" place="bottom" maxWidth="200">{description}</Tooltip>}
        {creditsCharged !== undefined && creditsCharged !== null && <span className="notification-credits-charged">
          {IconFactory('Credit')}
          {creditsCharged}
        </span>}
      </div>
      <div className="notification-actions">
        {action && onClick && <Button
          className="notification-custom-action"
          onClick={onAction}
          variant={btnVariant}
          size="tiny"
        >
          {action}
        </Button>}
        {<span className="notification-close" onClick={onCloseClickWrapper}>{IconFactory('Remove')}</span>}
      </div>
    </div>
  );
};

export default Notification;

Notification.propTypes = {
  closeToast: PropTypes.func,
  indication: PropTypes.oneOf(Object.values(INDICATION)).isRequired,
  message: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  btnVariant: PropTypes.string,
  onCloseClick: PropTypes.func,
  descriptionInTooltip: PropTypes.bool,
  showOverflow: PropTypes.bool,
  creditsCharged: PropTypes.number,
};

Notification.defaultProps = {
  className: '',
  btnVariant: 'text',
  descriptionInTooltip: false,
  showOverflow: false,
};
